<template>
    <div class="card">
      <Datatable
        tableId="jobStacksTable"
        uniqueField="name"
        :columns="columns"
        :data="jobStacks"
        :compact="true"
        :selectCheckboxes="true"
        :orderColumn="orderColumn"
        :formatColumn="formatColumn"
        :deletable="true"
        @deleteRows="showDeletePage"
        :detailColumn="{
          baseUrl: 'job-stacks/',
          identifier: 'name',
          identifierName: 'name',
          name: 'Job Stack',
        }"
      />
    </div>
  </template>
  
  <script>
  import Datatable from "../../components/Datatable.vue";
  import { mapActions } from "vuex";
  
  export default {
    name: "JobStacks",
    components: { Datatable },
    data() {
      return {
        columns: [
          { data: "name" },
          { data: "type" },
          { data: "created_by", title: "Created by" },
          { data: "created_at", title: "Created at" },
        ],
        orderColumn: [5, "desc"],
        //Note: index - table column index which need to formatted
        formatColumn: [
          {
            index: 5,
            type: "datetime",
          },
        ],
        loading: false,
      };
    },
    computed: {
      jobStacks() {
        return this.$store.state.amdp.jobStacks;
      },
    },
    beforeMount() {
      this.$store.dispatch("amdp/fetchJobStacks");
    },
    methods: {
      ...mapActions({
        showModal: "showModal",
      }),
      showDeletePage(rows) {
        this.showModal({ component: "DeleteJobStack", data: rows });
      },
    },
  };
  </script>
  
  <style scoped></style>
  